export const regionMap: Record<string, string> = {
  cus: "US Central (CUS)",
  uae: "UAE (UAE)",
};

export const regionsUrlKeys = {
  cus: "cus",
  uae: "uae",
};
